import PropTypes from 'prop-types';
import prepareTranslate from '@/helpers/dictionary';
import { ACCORD_TYPE } from '@/helpers/enums';
import SectionView from '../../SectionView';
import Modal from '../../DetailsModal';

const ClientViewForm = (props) => {
  const { opened, close, client } = props;
  const t = prepareTranslate();

  const shouldShowValue = (val) => val !== undefined
    && val !== null
    && !(typeof val === 'number' && val === 0)
    && !(typeof val === 'string' && val.trim() === '0');

  const buildClientDetails = (clientData) => {
    const accordTypeLabel = ACCORD_TYPE.find((a) => a.value === clientData.accordType)?.label || '';
    const commission = clientData.accordType === ACCORD_TYPE[0].value
      ? clientData.agentCommission
      : clientData.employeeAgentCommission;

    return [
      [
        {
          title: t('components.viewAgentClients.company'),
          value: clientData.companyId?.hebrew,
        },
        {
          title: t('components.viewAgentClients.branch'),
          value: clientData.branchId?.hebrew,
        },
        {
          title: t('components.viewAgentClients.clientNumber'),
          value: clientData.clientNumber,
        },
        {
          title: t('components.viewAgentClients.clientName'),
          value: clientData.clientName,
        },
      ].filter(Boolean),
      [
        {
          title: t('components.viewAgentClients.accordType'),
          value: accordTypeLabel,
        },
        {
          title: t('components.viewAgentClients.hp'),
          value: clientData.uid,
        },
        shouldShowValue(commission) && {
          title: t('components.viewAgentClients.agentCommission'),
          value: commission,
        },
        shouldShowValue(clientData.comments) && {
          title: t('components.viewAgentClients.comments'),
          value: clientData.comments,
        },
      ].filter(Boolean),
    ];
  };

  if (!client) return null;

  return (
    <Modal
      opened={opened}
      close={close}
      label={t('components.viewAgentClients.view')}
    >
      {buildClientDetails(client).map((lines, idx) => (
        <SectionView key={idx} lines={lines} />
      ))}
    </Modal>
  );
};

ClientViewForm.propTypes = {
  opened: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  client: PropTypes.object,
};

export default ClientViewForm;
